/**
 * 可行性评估卡片组件
 */

import React from 'react';
import { Card, Form, Row, Col, Input, Select } from 'antd';
import { FEASIBILITY_OPTIONS } from './constants';

const { TextArea } = Input;

export const FeasibilityCard: React.FC = () => {
    return (
        <Card title="✅ 可行性评估" bordered={false}>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item
                        name={['research_data', 'technical_feasibility']}
                        label="技术可行性"
                    >
                        <Select
                            options={FEASIBILITY_OPTIONS as any}
                            placeholder="评估技术难度"
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        name={['research_data', 'supply_chain_feasibility']}
                        label="供应链可行性"
                    >
                        <Select
                            options={FEASIBILITY_OPTIONS as any}
                            placeholder="评估供应链难度"
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        name={['research_data', 'financial_feasibility']}
                        label="资金可行性"
                    >
                        <Select
                            options={FEASIBILITY_OPTIONS as any}
                            placeholder="评估资金压力"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'risk_assessment']}
                        label="风险评估"
                    >
                        <TextArea
                            rows={3}
                            placeholder="列出主要风险和应对措施..."
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default FeasibilityCard;
